module.exports = __webpack_public_path__ + "static/media/1POLICY14.12829ba1.jpg";